var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scroll-page',{attrs:{"pull-reload":false}},[_c('list-talks',{attrs:{"group_id":_vm.group_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }